import React, { createContext, useContext, useState, useCallback } from 'react';

const GestureContext = createContext();

export const useGesture = () => {
    const context = useContext(GestureContext);
    if (!context) {
        throw new Error('useGesture must be used within a GestureProvider');
    }
    return context;
};

export const GestureProvider = ({ children }) => {
    const [lastGesture, setLastGesture] = useState({ name: '', time: 0, pos: { x: 0.5, y: 0.5 } });
    const [gesturesEnabled, setGesturesEnabled] = useState(false);
    const [cardNavActive, setCardNavActive] = useState(false);

    const emitGesture = useCallback((gestureName, pos) => {
        setLastGesture({
            name: gestureName,
            time: Date.now(),
            pos: pos || { x: 0.5, y: 0.5 }
        });
    }, []);

    return (
        <GestureContext.Provider value={{
            lastGesture,
            emitGesture,
            gesturesEnabled,
            setGesturesEnabled,
            cardNavActive,
            setCardNavActive
        }}>
            {children}
        </GestureContext.Provider>
    );
};
